import React from 'react';


export const systemVariables = [
    {
        variable: "$useradmin",
        description: "Name of the account admin"
    },
    {
        variable: "$UserName",
        description: "Name of the user"
    },
    {
        variable: "$department",
        description: "Department of the user"
    },
    {
        variable: "$useradminemail",
        description: "Email id of the account admin"
    },
    {
        variable: "$RequestorName",
        description: "Name of the requestor"
    },
    {
        variable: "$type",
        description: "Type of the tattle"
    },
    {
        variable: "$TattleDescription",
        description: "Description of the tattle"
    },
    {
        variable: "$AttachmentLink",
        description: "Attached file in the tattle"
    },
    {
        variable: "$CustomerSupportTeam",
        description: "Email id of Tattle support team"
    },
    {
        variable: "Message Type",
        description: "Type of the message."
    },
    {
        variable: "$user",
        description: "Email id of the user "
    },
    {
        variable: "$AssigneeName",
        description: "Assigned user of the tattle"
    },
    {
        variable: "$Tattlevariable",
        description: ""
    },
    {
        variable: "$monitors",
        description: "Users added in cc for a tattle"
    },
    {
        variable: "$assignee",
        description: "Email id of the assignee of the tattle"
    },
    {
        variable: "$customeradmin",
        description: ""
    },
    {
        variable: "$NoteSubmittor",
        description: "Name of the user who submits note"
    },
    {
        variable: "$Note",
        description: "Note added to the tattle"
    },
    {
        variable: "$MessageType",
        description: "Type of the message."
    },
    {
        variable: "$users",
        description: "Email id of the user"
    },
    {
        variable: "$InternalAssigneeName",
        description: "Assigned user of the tattle"
    },
    {
        variable: "$CharofTitle",
        description: "Tittle of the tattle"
    },
    {
        variable: "$internalassignee",
        description: "Email id of the assignee of the tattle"
    },
    {
        variable: "$newStatus",
        description: "Current status of the tattle after change"
    },
    {
        variable: "$CustomerAccountName",
        description: ""
    },
    {
        variable: "$url",
        description: "URL to redirect to the website"
    },
    {
        variable: "$email",
        description: "Email Id of the user"
    },
    {
        variable: "$Password",
        description: "Password of the user"
    },
    {
        variable: "$CCname",
        description: "Name of the user in cc for the tattle"
    },
    {
        variable: "$cc",
        description: "Email id of the user added in cc for the tattle"
    },

]







    
